/**
 * custom plugin for NAB slider
 */
jQuery.fn.nabCustomSlider = function(options) {

	var emptyFunction = function() { };
	var defaults = {
		orientation: "horizontal"	//or vertical
		, value: 0				//default value/starting position of handle (first handle only)
		, values: []				//if multiple handles, specify values - "range" property must be true
		, range: false			//If set to true, the slider will detect if you have two handles and create a stylable range element between these two. Two other possible values are 'min' and 'max'. A min range goes from the slider min to one handle. A max range goes from one handle to the slider max.
		, min: 0
		, max: 20
		, step: 1
		, startValue: null			//used for right to left sliders (zero marker is already known - incrementing starts from this point and uses the multiplier)
		, multiplier: null			//used for right to left sliders (position and label multiplier for spacing - used with startValue and incremented from that position)		
		, markerStep: null
		, labelStep: null
		, manualStep: []				//set custom label and percentage positions for positive and negative sliders
		, stepLabelType: ""				//string that follows step indicators, e.g. "%"
		, slide: function(evt, ui) {
			//console.log("sliding: ", ui.value); 
		}
		, start: function(evt, ui) {
			//console.log("started: ", ui.value); 
		}
		, stop: function(evt, ui) {
			//console.log("stopped: ", ui.value); 
		}
		, change: function(evt, ui) {
			//console.log("changed: ", ui.value);
		}
	};

	//can't define a step interval without showing the labels, too
	if (options.labelStep >= 1) {
		defaults.showStepLabels = true;
	}

	//some overridable defaults for specific slider types
	if ("marker" == options.sliderType) {
		defaults.handleType = "pointer";
		defaults.showStepLabels = true;
		defaults.step = 1;
		defaults.markerStep = 10;
		defaults.labelStep = 20;
	}

	if ("negPosRange" == options.sliderType) {
		defaults.change = function(evt, ui) {
			showPosNegRange(evt, ui);
		};
        defaults.slide = function(evt, ui) {
			showPosNegRange(evt, ui);
		};
    }

	if ("rightToLeftRange" == options.sliderType) {
		defaults.value = options.max;
		defaults.change = function(evt, ui) {
			showRightToLeftRange(evt, ui);
		};
        defaults.slide = function(evt, ui) {
			showRightToLeftRange(evt, ui);
		};
    }

	if ("rightToLeftRangeNeg" == options.sliderType) {
		defaults.value = options.max;
		defaults.change = function(evt, ui) {
			showRightToLeftRange(evt, ui);
		};
        defaults.slide = function(evt, ui) {
			showRightToLeftRange(evt, ui);
		};
    }

	if ("twoHandle" == options.sliderType) {
		defaults.range = true;
	}

	if ("leftRange" == options.sliderType) {
		defaults.change = function(evt, ui) {
			showLeftRange(evt, ui);
		};
    }

	//do we have any other call backs to also execute?
	//this allows us to define some default callback event handler while also specifiying custom stuff
	//additionalCallBacks is an object of possibly 4 properties that are functions that is passed as an OPTION
	/*
	e.g.
	
	additionalCallBacks = {
	start:function(){ doSomething(); },
	stop:function(){ foo(); }
	}
	*/

	//define empty funcs first so we aren't forced to pass them all if we don't want to
	var addlCallBackFuncs = {
		slide: emptyFunction,
		change: emptyFunction,
		start: emptyFunction,
		stop: emptyFunction
	};

	options.oSliderEvents = jQuery.extend(addlCallBackFuncs, options.oSliderEvents);

	var defaultFuncs = {
		slide: defaults.slide,
		change: defaults.change,
		start: defaults.start,
		stop: defaults.stop
	};

    defaults.slide = function(evt, ui) {
		defaultFuncs.slide(evt, ui);
		options.oSliderEvents.slide(evt, ui);
	};
    defaults.change = function(evt, ui) {
		defaultFuncs.change(evt, ui);
		options.oSliderEvents.change(evt, ui);
	};
    defaults.start = function(evt, ui) {
		defaultFuncs.start(evt, ui);
		options.oSliderEvents.start(evt, ui);
	};
    defaults.stop = function(evt, ui) {
		defaultFuncs.stop(evt, ui);
		options.oSliderEvents.stop(evt, ui);
	};

    //now GO
	var config = jQuery.extend(defaults, options);
	var o = config;

	//create slider
	var $slider = this.slider(config);

	//now customize the slider
	if (o.handleType) {
		$slider.find("a").addClass("ui-slider-handle-" + o.handleType);
	}

	//we don't need these
	$slider.addClass("contain").removeClass("wsod_ui-corner-all wsod_ui-widget-content");
	$slider.find("a").removeClass("wsod_ui-corner-all wsod_ui-widget-content");

	//define a width, otherwise default to 100%
	if (o.width) {
		$slider.css("width", o.width);
	}

	if ("marker" == o.sliderType) {
		$slider.addClass("sliderType-marker");
		//set marker, AND left and right sides of the marker
		//$slider.append('<div class="stepIndicator markerStep">');
		$slider.append('<div class="markerBg markerGrn" />');
		$slider.append('<div class="markerBg markerRed" />');
	}

	if ("negPosRange" == o.sliderType || "leftRange" == o.sliderType) {
		$slider.append('<div class="ui-slider-range wsod_ui-widget-header" />');
	}

	if ("rightToLeftRange" == o.sliderType) {
		$slider.append('<div class="ui-slider-range wsod_ui-widget-header" style="right:0pt;" />');
	}

	if ("rightToLeftRangeNeg" == o.sliderType) {
		$slider.append('<div class="ui-slider-range wsod_ui-widget-header" style="right:0pt;" />');
	}


	//set left and right ends of the slider
	$slider.append('<div class="endPipe leftEnd" />');
	$slider.append('<div class="endPipe rightEnd" />');

	//do increments
	if (o.step > 0 && o.showStepLabels === true) {

		//get positions and their labels
		if (o.manualStep.length > 0) {
			//positive and negative slider with custom percentage/labels
			var stepData = getPostionsAndLabelsCustom();
		}
		else if (options.sliderType == "rightToLeftRange") {
			//right to left slider with positive numbers
			//			var stepData = getPostionsAndLabelsRL();
			var stepData = getPostionsAndLabelsCustom();
		}
		else if (options.sliderType == "rightToLeftRangeNeg") {
			//right to left slider with negatice numbers
			var stepData = getPostionsAndLabelsRL("negative");
		}
		else {
			//all othe
			var stepData = getPostionsAndLabels();
		}

		var $markerPipe;
		var markerPipeSet = false;

		//draw pipes
		jQuery.each(stepData.positions, function(i, index) {
			//only show these pipes on the inside of the slider
			if (i === 0 || i === stepData.positions.length - 1) {
				return true;
			}
			var pos = index - 1;
			var $stepIndicator = jQuery("<div />")
									.addClass("stepIndicator")
									.css("left", pos + "%")
									.appendTo($slider)
								;

			//set orange pipe for "marker" slider
			if ("marker" == o.sliderType && o.markerValue !== null && !markerPipeSet) {
				$markerPipe = jQuery("<div />").addClass("stepIndicator markerStep").appendTo($slider);
				markerPipeSet = true;
			}

			if ("marker" == o.sliderType && o.labelStep !== null) {
				if (index % o.labelStep > 0) {
					$stepIndicator.addClass("stepIndicatorSmallPipe");
				}
			}

		});

		//draw labels
		jQuery.each(stepData.positions, function(i, index) {
			var pos;
			if (i === 0) {
				pos = 0;
			} else if (i === stepData.positions.length - 1) {
				pos = $slider.find(".rightEnd").position().left;
				if (pos == 0) {
					pos = "100%";
				}
			} else {
				var eq = i - 1;
				pos = $slider.find("div.stepIndicator:not(.markerStep):eq(" + eq + ")").position().left || $slider.find("div.stepIndicator:not(.markerStep):eq(" + eq + ")").css("left");
			}

			//we want labels every other position for this sliderType
			i = ("marker" == o.sliderType) ? i / 2 : i;

			var stepLabel = getStepLabelValue(stepData, i);

			var $label = jQuery("<label />")
				.addClass("sliderTextLabel" + i)
				.css("left", pos)
				.html(stepLabel)
				.appendTo($slider)
			;

			//center label under pipe -- pipe width is 4 pixels so offset the position by that additional width.
			//IE was choking on '%' symbol in pos value
			var numberPos = parseInt(pos, 10) - (($label.width() / 2) - 4);
			$label.css("left", numberPos);
		});

		if ("marker" == o.sliderType) {
			//set position of orange marker line
			var leftPosAsPercent = getPositionOfValue(stepData, o.markerValue);
			$markerPipe.css("left", leftPosAsPercent);
			//set position and width of red background
			$slider.find("div.markerRed").css({
				"left": 0,
				"width": leftPosAsPercent
			});
			//set position and width of green background
			var greenWidth = 100 - Number(leftPosAsPercent.replace("%", ""));
			$slider.find("div.markerGrn").css({
				"left": leftPosAsPercent,
				"width": greenWidth + "%"
			});
		}

	};


	/**
	* Reveals red or green range background on slider bar.
	*/
	function showPosNegRange(evt, ui) {
		var handleValue = ui.value;
		var color = (handleValue < 0) ? "#E9C4B9" : "#ADCAA2";
		var startAt = o.width / 2;
		var sliderAt = $(ui.handle).position().left;
		var width = Math.abs(sliderAt - startAt);
		var leftEnd = (handleValue < 0) ? sliderAt : startAt;
		var $range = $slider.find(".ui-slider-range"); //div to apply color to
		$range.css({
			"left": leftEnd,
			"width": width,
			"background-color": color
		});
	}


	/**
	* Reveals colored range positioned from right sliding left.
	*/
	function showRightToLeftRange(evt, ui) {
		var handleValue = ui.value;
		var color = (handleValue < 0) ? "#E9C4B9" : "#ADCAA2";
		var startAt = o.width;
		//var sliderAt = $slider.find("a.ui-slider-handle").position().left; // Leaving this commented intentionally - jm 2jan2020
        var sliderAt = $slider.find(".ui-slider-handle").position().left;
        var width = Math.abs(sliderAt - startAt);
		var $range = $slider.find(".ui-slider-range");
		$range.css({
			"right": 0,
			"width": width,
			"background-color": color
		});
	}

	function showLeftRange(evt, ui) {
		var handleValue = ui.value;
		var color = "#ADCAA2";
		var startAt = 0;
		var sliderAt = $slider.find(".ui-slider-handle").position().left;
		var width = Math.abs(sliderAt + startAt);
		var $range = $slider.find(".ui-slider-range");
		$range.css({
			"left": 0,
			"width": width,
			"background-color": color
		});
	}

	/**
	* Find the position of a step indicator by value
	*
	* returns a string, e.g. 29%
	*/
	function getPositionOfValue(stepData, markerVal) {
		var positions = stepData.positions;
		for (var i = 0; i < positions.length; i++) {
			if (markerVal == positions[i]) {
				return $slider.find("div.stepIndicator:not(.markerStep):eq(" + (i - 1) + ")").css("left");
			}
		};
		return markerVal + "%"; //basically a fail-safe
	}

	/**
	* Get the label to display under a step indicator by index
	*/
	function getStepLabelValue(stepData, index) {
		var val;
		//first label? always 0 if o.min = 0
		if (index === 0 && stepData.labels[index] === 0) {
			val = 0;
		} else {
			//get the value from the array, if it's not undefined
			val = stepData.labels[index];
			if (val == undefined) {
				val = ""; //we must be displaying labels on every other pipe or something...just send back empty string	
			}
		}
		//does it need a format?
		if (o.stepLabelType == "percent" || 
			(o.stepLabelType == "Percent" && index === 2)) {
			val = val + "%";
		} else if (o.stepLabelType == "dollar" ||
			(o.stepLabelType == "Priceaud" && (index === 1 || index ===2))) {
			val = "$" + val;
		}
		return val;
	}

	/**
	* Based on inputs, find increment(step) labels and their position on the slider rail
	* 
	* returns an object of arrays
	*/
	function getPostionsAndLabels() {
		var positions = [];
		var labels = [];
		var PIPE_WIDTH = 4; //
		var range = o.max - o.min; //get range
		//check to see if we have a markerStep defined and use it
		var step = (o.markerStep !== null) ? o.markerStep : o.step;

		if (o.sliderType == "twoHandle" && o.stepLabelCustomValues && o.stepLabelCustomValues.length == 2) {

			//
			// Use custom start and and values as specified by the caller
			//
			// NOTE: We use dummy values for the first and last so that our labels can be positioned where
			// we want them.  Otherwise they're positioned at the beginning and end of the slider, and that
			// doesn't work when displayed in the Distribution Range Control.  
			//

			labels.push("");
			labels.push(o.stepLabelCustomValues[0]);
			labels.push(o.stepLabelCustomValues[1]);
			labels.push("");

			positions.push(0);
			positions.push(5);
			positions.push(95);
			positions.push(100);
		}
		else {


			//loop over range, start to finish (left to right on the slider)
			for (var i = o.min; i <= range; i++) {
				//if we need a label/pipe every step, go here.
				if (step === 1) {
					//get numerical value of this position for the label
					if (o.labelStep === null) {
						labels.push(i);
					}
					//get position in percentage from left edge of slider
					var pos = (i / o.max) * 100;
					//we only care about positions greater than 0
					if (pos >= 0) {
						//if the min value on the slider is negative, divide by 2 to get labeling correct
						if (o.min < 0) { pos = pos / 2; }
						//now keep this value
						positions.push(pos);
					}
				} else {
					//we have labels/pipes at a defined interval (must be an even divisor of range)

					if (Math.abs(i) % step < 1) {
						//get numerical value of this position for the label
						//do we have a defined labelStep that may be different than o.step?
						if (o.labelStep !== null && Math.abs(i) % o.labelStep < 1) {
							labels.push(i);
						} else {
							if (o.labelStep === null) {
								labels.push(i);
							}
						}
						//get position in percentage from left edge of slider
						var pos = (i / o.max) * 100;
						if (pos >= 0) {
							//if the min value on the slider is negative, divide by 2 to get labeling correct
							if (o.min < 0) { pos = pos / 2; }
							//now keep this value
							positions.push(pos);
						}
					}
				}
			}
		}

		return { positions: positions, labels: labels };
	}


	/**
	* Positive and Negative Sliders with custom position and label requirements
	*/
	function getPostionsAndLabelsCustom() {
		var percentages = o.manualStep;
		var midPoint = 50;
		var defaultLabels = [o.min, o.max, 50];
		var defaultPositions = [0, 50, 100];

		// Get the positions based off the percentages
		for (i = 0; i < percentages.length; i++) {
			var pos = percentages[i];
			// positive numbers
			defaultPositions.push(midPoint + pos);
			defaultLabels.push(pos);
			// negative numbers
			defaultPositions.push(midPoint - pos);
			defaultLabels.push(pos * (-1));
		}

		// Sort the values in numerical order
		allPositions = defaultPositions.sort(function(a, b) { return a - b });
		allLabels = defaultLabels.sort(function(a, b) { return a - b });

		var positions = allPositions;
		var labels = allLabels;

		return { positions: positions, labels: labels };
	}


	/**
	* Right to Left Sliders for positive and negative numbers
	*/
	function getPostionsAndLabelsRL(type) {
		var startValue = o.startValue;
		var multiplier = o.multiplier;
		var defaultLabels = [0, startValue];
		if ("negative" == type) {
			var defaultPositions = [100, (100 - ((startValue * -1) / (o.min * -1) * 100))];
			var pos = startValue * -1;
			// Get the positions based off the percentages
			for (i = (startValue * -1); i < (o.min * -1); i++) {
				pos = pos * multiplier;
				i = pos;
				defaultPositions.push((100 - ((pos) / (o.min * -1) * 100)));
				defaultLabels.push((pos * -1));
			}
		}
		else {
			var defaultPositions = [0, ((startValue / o.max) * 100)];
			var pos = startValue;
			// Get the positions based off the percentages
			for (i = startValue; i < o.max; i++) {
				pos = pos * multiplier;
				i = pos;
				defaultPositions.push((pos / o.max) * 100);
				defaultLabels.push(pos);
			}
		}
		// Sort the values in numerical order		
		var positions = defaultPositions.sort(function(a, b) { return a - b });
		var labels = defaultLabels.sort(function(a, b) { return a - b });
		return { positions: positions, labels: labels };
	}

	//return jQuery
	return this;
};

var wsod_slider = {};

(function($) {

	wsod_slider.init = function() {
		var $sliders = $('div.sliderContainer').each(function() {

			var $that = $(this);
			var args = wsod_slider.getArgs(this);
			if ($that.attr('slider') == 'marker') {
				args.markerValue = $that.attr('markerVal');
				wsod_slider.initMarkerSlider(args);
			} else if ($that.attr('slider') == 'goals') {
				wsod_slider.initGoalsSlider(args);
			} else if ($that.attr('slider') == 'basic') {
				wsod_slider.initBasicSlider(args);
			} else if ($that.attr('slider') == 'moreless') {
				wsod_slider.initMoreOrLessSlider(args);
			} else if ($that.attr('slider') == 'ormore') {
				wsod_slider.initOrMoreSlider(args);
			}
		});
	};

    wsod_slider.getArgs = function(el) {
		var $that = (el.length) ? el : $(el);
		var args = {
			el: el
		, value: $that.attr('initVal')
		};

		if ($that.attr('width')) {
			args.width = $that.attr('width');
		}

		return args;
	};

    wsod_slider.initBasicSlider = function(args) {
		args = args || {};
		var $container = $(args.el);

		$("div.slider", $container).nabCustomSlider({
			value: args.value || 0,
			step: args.step || 1,
			showStepLabels: args.labels || false,
			stepLabelType: "percent",
			width: args.width || 200
		});
	};

    wsod_slider.initMarkerSlider = function(args) {
		args = args || {};
		var $container = $(args.el);

		$("div.slider", $container).nabCustomSlider({
			value: args.value || 0, 	//this is the start value of the slider handle
			min: args.beginValue || 0, 		//left end value
			max: args.endValue || 100, 	//right end value	
			markerValue: args.markerValue || 28, //position of orange pipe (red/green splitter)
			width: args.width || 315, 	//slider width
			sliderType: "marker", //type			
			slide: function(evt, ui) {
				$("span.sliderValue", $container).text(ui.value);
			}
		});
	};

    wsod_slider.initMoreOrLessSlider = function(args) {
		args = args || {};
		var $container = $(args.el);

		$("div.slider", $container).nabCustomSlider({
			value: args.value || 0,
			step: 1,
			labelStep: 25,
			markerStep: 25,
			min: -50,
			max: 50,
			stepLabelType: "percent",
			width: 315,
			sliderType: "negPosRange",
			oSliderEvents: {
				slide: function(evt, ui) {
					$("span.sliderValue", $container).text(ui.value + "%");
				}
			}
		});
	};

    wsod_slider.initOrMoreSlider = function(args) {
		args = args || {};
		var $container = $(args.el);

		$("div.slider", $container).nabCustomSlider({
			value: args.value || 1,
			step: 1,
			labelStep: 50,
			markerStep: 50,
			min: 1,
			max: 100,
			stepLabelType: "percent",
			width: 315,
			sliderType: "rightToLeftRange",
			oSliderEvents: {
				slide: function(evt, ui) {
					$("span.sliderValue", $container).text(ui.value + "%");
				}
			}
		});
	};

    wsod_slider.initGoalsSlider = function(args) {
		args = args || {};
		var $container = $(args.el);

		$("div.slider", $container).nabCustomSlider({
			value: args.value || 0,
			step: 10,
			width: 110,
			min: 0,
			max: 1000,
			showStepLabels: false,
			sliderType: "leftRange",
			stepLabelType: "percent",
			oSliderEvents: {
				slide: function(evt, ui) {
					var $that = $(ui.handle);
						$("input.txt_contributelevel", $container.siblings('div.errorPlace')).val(ui.value);
					if (ui.value >= 100) {
						$that.parent().slider("option", "step", 100);
					} else {
						$that.parent().slider("option", "step", 10);
					}
				},
				stop: function(evt,ui) {
					wsod_goals.load();
				}
			}
		});
	};

})(jQuery);
